import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

import { USER_LOGOUT } from "../actions/types";
import advancedSearchReducer from "./advancedSearchReducer";
import appReducer from "./appReducer";
import billsOfLadingReducer from "./billsOfLadingReducer";
import contactUsReducer from "./contactUsReducer";
import customerReducer from "./customerReducer";
import documentsReducer from "./documentsReducer";
import loadsReducer from "./loadsReducer";
import millOrderReducer from "./millOrderReducer";
import notificationsReducer from "./notificationsReducer";
import orderedProductsReducer from "./orderedProductsReducer";
import prePlanningReducer from "./prePlanningReducer";
import purchaseOrderReducer from "./purchaseOrderReducer";
import unitOfMeasurementReducer from "./unitOfMeasurementsReducer";

const applicationReducer = combineReducers({
  app: appReducer,
  advancedSearch: advancedSearchReducer,
  billsOfLading: billsOfLadingReducer,
  contactUs: contactUsReducer,
  customer: customerReducer,
  documents: documentsReducer,
  form: formReducer,
  loads: loadsReducer,
  millOrder: millOrderReducer,
  notifications: notificationsReducer,
  orderedProducts: orderedProductsReducer,
  prePlanning: prePlanningReducer,
  purchaseOrder: purchaseOrderReducer,
  unitOfMeasurements: unitOfMeasurementReducer
});

const rootReducer = (state, action) => {
  if (action.type === USER_LOGOUT) {
    state = undefined; // eslint-disable-line
  }

  return applicationReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js